import { useRef, useState } from "react";
import OptionsIcon from "../../../assets/icons/OptionsIcon";
import ProfileIcon from "../../../assets/icons/ProfileIcon";
import RotateIcon from "../../../assets/icons/RotateIcon";
import TrashIcon from "../../../assets/icons/TrashIcon";
import ChangeUserFlowModal from "../../../components/general/AlertModals/ChangeFlowUserModal";
import DelegateAllModal from "../../../components/general/AlertModals/DelegateAllModal";
import ExcludeFlowModal from "../../../components/general/AlertModals/ExcludeFlowModal";
import UndoFlowModal from "../../../components/general/AlertModals/UndoFlowModal";
import { useOutsideDrop } from "../../../hooks/useOutsideDrop";
import {
  Container,
  Content,
  DropMenu,
  Line,
  ListItem,
  MainOption,
  UList,
} from "./styles";
import { useSelector, useDispatch } from "react-redux";

import {
  handleUndoActived,
  handleRemoveActivedFlow,
} from "../../../state/activedFlows/actions";
import { toastAlert } from "../../../components/Toastify/index";
import { useHistory } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
const OptionsButton = () => {
  const [openOptions, setOptions] = useState(false);
  const [openDelete, setDelete] = useState(false);
  const [openFlowUser, setFlowUser] = useState(false);
  const [openUndo, setOpenUndo] = useState(false);

  const [delegateAll, setDelegateAll] = useState(false);

  const clearState = () => setOptions(false);
  const wrapperRef = useRef(null);

  const dispatch = useDispatch();
  const history = useHistory();

  useOutsideDrop(wrapperRef, clearState);
  const pane = useSelector((state) => state.activedFlows.pane);
  const flowTitle = pane.flow?.title;

  async function undoState() {
    trackPromise(
      dispatch(handleUndoActived({ flowId: pane.flow._id }))
        .then((res) => {
          toastAlert({
            msg: `Última ação do fluxo ${pane.flow.title} foi desfeita!`,
          });
          setOpenUndo(false);
        })
        .catch((err) => {
          toastAlert({
            msg: `Ocorreu um erro ao tentar desfazer a ação: ${err}`,
            isError: true,
          });
          setOpenUndo(false);
        }),

      "undo-flow"
    );
  }

  const handleRemove = async () => {
    trackPromise(
      dispatch(handleRemoveActivedFlow({ flowId: pane.flow._id }))
        .then(() => {
          toastAlert({
            msg: `O fluxo: ${flowTitle} FOI REMOVIDO COM SUCESSO!`,
          });

          history.push("/activedflows/");
        })
        .catch((err) => {
          toastAlert({
            msg: `Ocorreu um ERRO ao remover o Fluxo Ativo: ${err.message} - CODE: ${err.code}`,
            isError: true,
          });
        }),
      "remove-flow"
    );
  };

  return (
    <>
      <Container ref={wrapperRef}>
        <Content open={openOptions} onClick={() => setOptions(!openOptions)}>
          <OptionsIcon />
          <span>Mais opções</span>
        </Content>

        {openOptions && (
          <DropMenu>
            <MainOption
              onClick={() => {
                setDelegateAll(true);
                setOptions(false);
              }}
            >
              Gerenciar tarefas...
            </MainOption>
            <Line />
            <UList>
              {process.env.NODE_ENV === "development" ? (
                <ListItem
                  onClick={() => {
                    setOptions(false);
                    setOpenUndo(true);
                  }}
                >
                  Desfazer Ação <RotateIcon height="0.70412rem" />
                </ListItem>
              ) : null}
              <ListItem
                onClick={() => {
                  setFlowUser(true);
                  setOptions(false);
                }}
              >
                Alterar Responsável <ProfileIcon height="0.8208rem" />
              </ListItem>
              <ListItem
                onClick={() => {
                  setDelete(true);
                  setOptions(false);
                }}
              >
                Deletar Fluxo <TrashIcon height="0.645rem" />
              </ListItem>
            </UList>
          </DropMenu>
        )}
      </Container>

      {delegateAll ? (
        <DelegateAllModal
          isOpen={delegateAll}
          onClose={() => setDelegateAll(false)}
          selector="#root"
        />
      ) : null}

      {openFlowUser ? (
        <ChangeUserFlowModal
          isOpen={openFlowUser}
          onClose={() => setFlowUser(false)}
          selector="#root"
        />
      ) : null}

      {openUndo ? (
        <UndoFlowModal
          isOpen={openUndo}
          onConfirm={undoState}
          onClose={() => setOpenUndo(false)}
          selector="#root"
          flowName={flowTitle}
        />
      ) : null}

      {openDelete ? (
        <ExcludeFlowModal
          isOpen={openDelete}
          onClose={() => setDelete(false)}
          onConfirm={handleRemove}
          selector="#root"
          flowName={flowTitle}
        />
      ) : null}
    </>
  );
};

export default OptionsButton;
